import React from 'react';
import styled, { css } from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import Icon from '../Icon';
import { FocusStyles, FocusStylesInverted } from '../../styles/FocusStyles';
const StyledButton = styled.button `
  background: transparent;
  color: inherit; /* Required for dark-background footer */
  align-items: center;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-family: inherit;
  font-size: inherit;
  padding: 0;

  &:hover {
    color: ${props => props.theme.BrandPrimaryHover};
  }

  ${props => props.isInverted
    ? css `
          ${FocusStylesInverted};
        `
    : css `
          ${FocusStyles};
        `}
`;
const StyledIcon = styled(Icon) `
  height: 1rem;
  margin-right: 0.25rem;
  width: 1rem;
`;
export const OpenLanguageSwitchButton = ({ currentLanguage, dataTestId = undefined, idLanguageSwitch = undefined, isInverted = false, isOpen, onClick, }) => (React.createElement(StyledButton, { "aria-controls": idLanguageSwitch, "aria-expanded": isOpen, "data-testid": dataTestId, isInverted: isInverted, onClick: () => onClick(false), onKeyUp: event => {
        if (event.key === ' ') {
            // preventDefault() is required to prevent the LanguageSwitch from unintentionally selecting the first option
            event.preventDefault();
            onClick(true);
        }
    }, type: "button" },
    React.createElement(StyledIcon, { type: icons.place, title: null }),
    currentLanguage));
